import { EditorMultiTemplate } from "@dev/template-editor";
import i18n from '@/../i18n';

export const PRODUCT_MULTI_TEMPLATE_INDEX = 0;
export const PAYMENT_MULTI_TEMPLATE_INDEX = 1;
export const CONFIRMATION_MULTI_TEMPLATE_INDEX = 2;

export const TEMPLATE_EDITOR_NO_BLOCK_LIMIT = -1;
export const CHECKOUT_NAME_MAX_LENGTH = 60;
export const CHECKOUT_LINK_MAX_LENGTH = 2024;
export const LIST_NAME_MAX_LENGTH = 128;

export const MIN_PRICE_GENERAL = 1;
export const MIN_PRICE_CURRENCY_PLN = 2;

export enum MultiTemplateId {
    PRODUCT = 'product',
    PAYMENT = 'payment',
    CONFIRMATION = 'confirmation',
}

export const multiTemplates: EditorMultiTemplate[] = [
    {
        id: MultiTemplateId.PRODUCT,
        name: i18n.t('product')
    },
    {
        id: MultiTemplateId.PAYMENT,
        name: i18n.t('payment')
    },
    {
        id: MultiTemplateId.CONFIRMATION,
        name: i18n.t('confirmation')
    }
];

export const DEFAULT_TEMPLATE_EDITOR_META_DATA = "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";

export const landingsSpecialFields = ['checkoutproductname','checkoutprice'];

export const WEBSITE_CHECKOUT_URL = './checkout';

export const WEBSITE_BUY_URL = '{checkoutpaymenturl}';

export const LINK_TO_MERGE_FIELDS = [
    {
        name: 'checkoutproducturl',
        label: 'Checkout product URL',
        value: 'checkoutproducturl',
        useAdditionalInput: false,
        format: () => '{checkoutproducturl}',
    },
    {
        name: 'checkoutproductpageurl',
        label: 'Checkout product page URL',
        value: 'checkoutproductpageurl',
        useAdditionalInput: false,
        format: () => '{checkoutproductpageurl}',
    },
    {
        name: 'consent',
        label: 'Consent',
        value: 'consent',
        useAdditionalInput: false,
        format: () => '{consent}',
    },
    {
        name: 'consent tracking allow',
        label: 'Consent tracking allow',
        value: 'consenttrackingallow',
        useAdditionalInput: false,
        format: () => '{consenttrackingallow}',
    },
    {
        name: 'consent tracking deny',
        label: 'Consent tracking deny',
        value: 'consenttrackingdeny',
        useAdditionalInput: false,
        format: () => '{consenttrackingdeny}',
    },
    {
        name: 'contact profile',
        label: 'Contact profile',
        value: 'contactprofile',
        useAdditionalInput: false,
        format: () => '{contactprofile}',
    },
    {
        name: 'custom',
        label: 'Custom',
        value: 'custom',
        useAdditionalInput: true,
        format: (additionalInputValue: string) =>
            `${!additionalInputValue?.startsWith('{') ? '{' : ''}${additionalInputValue ?? ''}${
                !additionalInputValue?.endsWith('}') ? '}' : ''
            }`,
    },
    {
        name: 'unsubscribe',
        label:  'Unsubscribe',
        value: 'unsubscribe',
        useAdditionalInput: false,
        format: () => '{unsubscribe}',
    },
    {
        name: 'unsubscribe list',
        label: 'Unsubscribe list (mailing preferences)',
        value: 'unsubscribelist',
        useAdditionalInput: false,
        format: () => '{unsubscribelist}',
    },
    {
        name: 'unsubscribe from list',
        label: 'Unsubscribe from list',
        value: 'unsubscribefromlist',
        useAdditionalInput: false,
        format: () => '{unsubscribefromlist}',
    },
    {
        name: 'view online',
        label:  'View online',
        value: 'view',
        useAdditionalInput: false,
        format: () => '{view}',
    }
];
